module.exports = "\r\n<div class=\"toolListWrapper\">\r\n<div class=\"listItem\" *ngFor=\"let item of toolList\">\r\n    {{item}}\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/allPanels/tools/tools.component.html
// module id = ./src/app/allPanels/tools/tools.component.html
// module chunks = main